import React, { useEffect, useState } from 'react';
import './Notification.css';

const Notification = ({ message, type = 'success', onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsClosing(true);
    }, 1700); // Commence le fadeout un peu avant les 2 secondes

    const closeTimer = setTimeout(() => {
      onClose();
    }, 2000);

    return () => {
      clearTimeout(timer);
      clearTimeout(closeTimer);
    };
  }, [onClose]);

  return (
    <div className={`notification ${type} ${isClosing ? 'closing' : ''}`}>
      <p>{message}</p>
    </div>
  );
};

export default Notification; 